export default "__VITE_ASSET__B3bHcd4m__"